module.exports = __webpack_public_path__ + "img/rapha.1a8ecd3c.jpeg";